import {LoadingSkeleton} from '@github-ui/skeleton/LoadingSkeleton'

export function ReferencedEventVerificationStatusSkeleton(): React.ReactElement {
  return <LoadingSkeleton variant="pill" height="md" width="60px" />
}
